import { transformDTODate } from "@skylab-shared/core";
import { Transform } from "class-transformer";

export class DocumentPaymentDTO {
	public id: number;
	public amount: number;
	@Transform(transformDTODate, { toClassOnly: true }) public date: Date;
	public onDocument: boolean;
}
